import React from 'react';

const EnquiryFinalCTA = ({ data }) => {
    if (!data) return null;
    const { title, subtitle, buttonText, whatsappText, features } = data;

    const scrollToBooking = () => {
        document.getElementById('booking-form')?.scrollIntoView({ behavior: 'smooth' });
    };

    const openWhatsApp = () => {
        const referenceText = `Reference: ${window.location.href}`;
        const message = encodeURIComponent(`Hi! I'm ready to book my puja. Can you help me with the next steps?\n\n${referenceText}`);
        window.open(`https://wa.me/919869929292?text=${message}`, '_blank');
    };

    return (
        <section className="bg-[#FEEDD5] text-center px-6 py-10">
            <div className="max-w-4xl mx-auto">
                <h2 className="text-2xl md:text-3xl font-bold text-[#8A1C23] mb-6 leading-tight">
                    {title}
                </h2>

                <p className="text-lg text-gray-700 mb-8 max-w-2xl mx-auto leading-relaxed">
                    {subtitle}
                </p>

                <div className="flex justify-center gap-4 mt-4 flex-wrap mb-8">
                    <button
                        onClick={scrollToBooking}
                        className="bg-[#8A1C23] text-white py-4 px-8 rounded-md font-medium hover:bg-[#6B1419] transition-colors text-lg shadow-lg"
                    >
                        {buttonText}
                    </button>
                    <button
                        onClick={openWhatsApp}
                        className="bg-[#1DA851] text-white py-4 px-8 rounded-md font-medium hover:bg-[#128C7E] transition-colors text-lg shadow-lg"
                    >
                        {whatsappText}
                    </button>
                </div>

                <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-gray-600">
                    {features?.map((feature, index) => (
                        <div key={index} className="flex items-center gap-2">
                            <span className="text-green-500">✓</span>
                            <span>{feature}</span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default EnquiryFinalCTA;